import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'

interface CityOption {
  name: string
  region: string
  label: string
  kladr_id: string
  fias_id?: string | null
}

interface CityAutocompleteProps {
  label?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const CityAutocomplete: React.FC<CityAutocompleteProps> = ({
  label = 'Город', value, onChange, placeholder = 'Начните вводить город',
}) => {
  const [open, setOpen] = useState(false)
  const { data = [] } = useQuery({
    queryKey: ['city-directory', value],
    queryFn: () => apiClient.get<CityOption[]>('/v1/cities', { params: { search: value, limit: 12 } }),
    enabled: value.trim().length >= 2 && open,
    staleTime: 5 * 60 * 1000,
  })

  return (
    <div className="relative">
      <label className="mb-1.5 block text-sm font-medium text-secondary-700">{label}</label>
      <input
        value={value}
        onChange={(event) => { onChange(event.target.value); setOpen(true) }}
        onFocus={() => setOpen(true)}
        onBlur={() => window.setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        autoComplete="off"
        className="w-full rounded-lg border border-secondary-300 bg-white px-3 py-2.5 text-secondary-900 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20"
      />
      {open && value.trim().length >= 2 && data.length > 0 && (
        <ul className="absolute z-20 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-secondary-200 bg-white py-1 shadow-lg">
          {data.map((city) => (
            <li key={city.kladr_id}>
              <button
                type="button"
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => { onChange(city.name); setOpen(false) }}
                className="w-full px-3 py-2 text-left hover:bg-primary-50"
              >
                <span className="block text-sm font-medium text-secondary-900">{city.name}</span>
                <span className="block text-xs text-secondary-500">{city.region}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
